import { render, staticRenderFns } from "./account-refund.vue?vue&type=template&id=783a82b4&scoped=true&"
import script from "./account-refund.vue?vue&type=script&lang=js&"
export * from "./account-refund.vue?vue&type=script&lang=js&"
import style0 from "./account-refund.vue?vue&type=style&index=0&id=783a82b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783a82b4",
  null
  
)

export default component.exports